"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ThePanelBuildersWorkflow() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-panel-builders-workflow" className="py-16 md:py-24 bg-background text-foreground">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold mb-8 text-foreground">
            Why Do UL 508A Panel Builders Use Evermark?
          </h2>

          <div className="space-y-6 text-lg text-muted-foreground border-l-2 border-primary/30 pl-6 md:pl-8">
            <p>
              A UL 508A panel shop builds to a listing program, and the marking is part of that work — the equipment nameplate with the panel's electrical ratings, field-wiring and warning markings, control legends, and the schedule that identifies what each device does. Marking that doesn't match the build slows the shop and complicates the inspection.
            </p>
            <p>
              Evermark Industrial Solutions produces panel marking designed to align with UL 508A conventions and built to the shop's drawing. Panel builders upload a layout or nameplate schedule, approve a proof, and receive consistent, install-ready marking — the same way, every build.
            </p>
            <p>
              Evermark engraves the full marking set from one source — equipment nameplates, warning nameplates, legend plates, panel schedules, and arc flash labels — in phenolic, acrylic, stainless, or aluminum, so a panel shop isn't coordinating multiple vendors against one build date.
            </p>
          </div>

          
        </div>
      </div>
    </section>;
}